{
  "version": "GSHERO_ALGO_V1.1",
  "question_count": 28,
  "dimensions": [
    {
      "key": "E",
      "name": "情感表达度",
      "description": "低=克制含蓄；高=直球外显",
      "weight": 1.0
    },
    {
      "key": "M",
      "name": "情绪共情度",
      "description": "低=偏解决问题；高=擅长理解和接住情绪",
      "weight": 1.15
    },
    {
      "key": "A",
      "name": "行动守护度",
      "description": "低=尊重对方自行处理；高=遇事直接行动守护",
      "weight": 1.2
    },
    {
      "key": "D",
      "name": "关系主导度",
      "description": "低=平等松弛；高=强势主导、掌控节奏",
      "weight": 1.0
    },
    {
      "key": "S",
      "name": "稳定陪伴度",
      "description": "低=独立与距离感；高=稳定陪伴与确定感",
      "weight": 1.1
    },
    {
      "key": "R",
      "name": "心动刺激度",
      "description": "低=安稳低刺激；高=拉扯、冒险、高浓度心动",
      "weight": 1.05
    },
    {
      "key": "I",
      "name": "智谋理性度",
      "description": "低=直觉热血；高=谋定后动、策略理性",
      "weight": 0.95
    },
    {
      "key": "C",
      "name": "责任使命度",
      "description": "低=个人/爱情优先；高=使命、责任、大局优先",
      "weight": 0.9
    },
    {
      "key": "H",
      "name": "松弛幽默度",
      "description": "低=严肃深沉；高=松弛、嘴贫、喜剧感",
      "weight": 0.8
    },
    {
      "key": "G",
      "name": "成长共建度",
      "description": "低=成熟托底型；高=一起成长、共同升级型",
      "weight": 1.0
    }
  ],
  "questions": [
    {
      "id": 1,
      "text": "凌晨一点，你发了一句：“今天真的有点撑不住。”你最希望下一秒发生什么？",
      "options": [
        {
          "id": "A",
          "text": "“位置发我，我过来。”",
          "raw": {
            "E": 1.0,
            "M": 0.0,
            "A": 2.0,
            "D": 1.0,
            "S": 0.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": -1.0,
            "A": 1.5,
            "D": 1.0,
            "S": -0.25,
            "R": -0.25,
            "I": -0.5,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "电话直接打过来，不催你说，先陪着",
          "raw": {
            "E": 1.0,
            "M": 2.0,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": 1.0,
            "A": -0.5,
            "D": 0.0,
            "S": 0.75,
            "R": -0.25,
            "I": -0.5,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "先问发生了什么，然后一点点帮你把事情拆开",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 0.0,
            "D": -1.0,
            "S": 0.0,
            "R": 0.0,
            "I": 2.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.75,
            "M": 0.0,
            "A": -0.5,
            "D": -1.0,
            "S": -0.25,
            "R": -0.25,
            "I": 1.5,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "先发个很离谱的语音把你逗笑，再陪你处理",
          "raw": {
            "E": 1.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 2.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": 0.0,
            "A": -0.5,
            "D": 0.0,
            "S": -0.25,
            "R": 0.75,
            "I": -0.5,
            "C": 0.0,
            "H": 1.5,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 2,
      "text": "朋友局上，有人当着很多人的面阴阳了你一句。你最吃哪种处理方式？",
      "options": [
        {
          "id": "A",
          "text": "当场帮你顶回去，一点不让",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 2.0,
            "D": 2.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.25,
            "A": 1.0,
            "D": 1.5,
            "S": -0.25,
            "R": 0.75,
            "I": -0.75,
            "C": -0.25,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "不抢你的主场，但明显站到你这边",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 1.0,
            "D": -1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.75,
            "A": 0.0,
            "D": -1.5,
            "S": 0.75,
            "R": -0.25,
            "I": -0.75,
            "C": -0.25,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "当下不发作，之后用更聪明的办法把事情处理掉",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": 0.0,
            "R": 0.0,
            "I": 2.0,
            "C": 1.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.25,
            "A": 0.0,
            "D": -0.5,
            "S": -0.25,
            "R": -0.25,
            "I": 1.25,
            "C": 0.75,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "看起来笑眯眯的，一句话让对方自己尴尬",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 0.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 2.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.25,
            "A": -1.0,
            "D": 0.5,
            "S": -0.25,
            "R": -0.25,
            "I": 0.25,
            "C": -0.25,
            "H": 1.5,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 3,
      "text": "两个人出去旅行，到了才发现酒店临时没房了。他的哪种反应最让你安心？",
      "options": [
        {
          "id": "A",
          "text": "手机拿来，十分钟重新搞定",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 2.0,
            "D": 1.0,
            "S": 0.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.5,
            "A": 1.5,
            "D": 1.0,
            "S": -0.75,
            "R": 0.0,
            "I": 0.25,
            "C": 0.0,
            "H": -0.5,
            "G": -0.25
          }
        },
        {
          "id": "B",
          "text": "“问题不大，今晚这段肯定能讲一辈子。”",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 2.0,
            "G": 1.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.5,
            "A": -0.5,
            "D": 0.0,
            "S": -0.75,
            "R": 1.0,
            "I": -0.75,
            "C": 0.0,
            "H": 1.5,
            "G": 0.75
          }
        },
        {
          "id": "C",
          "text": "退赔、附近酒店、交通、Plan B已经全部查好了",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": -1.0,
            "I": 2.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.5,
            "A": -0.5,
            "D": 0.0,
            "S": 0.25,
            "R": -1.0,
            "I": 1.25,
            "C": 0.0,
            "H": -0.5,
            "G": -0.25
          }
        },
        {
          "id": "D",
          "text": "先问你累不累，今晚怎么玩听你的",
          "raw": {
            "E": 0.0,
            "M": 2.0,
            "A": 0.0,
            "D": -1.0,
            "S": 2.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 1.5,
            "A": -0.5,
            "D": -1.0,
            "S": 1.25,
            "R": 0.0,
            "I": -0.75,
            "C": 0.0,
            "H": -0.5,
            "G": -0.25
          }
        }
      ]
    },
    {
      "id": 4,
      "text": "你突然说：“我有点想辞职，去做一件收入不稳定但真的很想做的事。”你更希望他？",
      "options": [
        {
          "id": "A",
          "text": "“想做就去，我们一起想办法。”",
          "raw": {
            "E": 1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 2.0
          },
          "centered": {
            "E": 0.75,
            "M": 0.0,
            "A": -0.75,
            "D": 0.0,
            "S": -0.75,
            "R": 1.0,
            "I": -0.75,
            "C": 0.0,
            "H": 0.0,
            "G": 1.5
          }
        },
        {
          "id": "B",
          "text": "先把最坏情况跟你算清楚",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": -1.0,
            "I": 2.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": 0.0,
            "A": -0.75,
            "D": 0.0,
            "S": 0.25,
            "R": -1.0,
            "I": 1.25,
            "C": 0.0,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "C",
          "text": "“你去，我兜得住。”",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 2.0,
            "D": 1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": 0.0,
            "A": 1.25,
            "D": 1.0,
            "S": 0.25,
            "R": 0.0,
            "I": -0.75,
            "C": 0.0,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "D",
          "text": "不替你决定，但偷偷帮你把退路都准备好",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": -1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": 0.0,
            "A": 0.25,
            "D": -1.0,
            "S": 0.25,
            "R": 0.0,
            "I": 0.25,
            "C": 0.0,
            "H": 0.0,
            "G": -0.5
          }
        }
      ]
    },
    {
      "id": 5,
      "text": "你越喜欢一个人，反而越容易变成哪一种？",
      "options": [
        {
          "id": "A",
          "text": "忍着不说，等他自己发现",
          "raw": {
            "E": -2.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -2.0,
            "M": 0.75,
            "A": -0.5,
            "D": 0.0,
            "S": 0.5,
            "R": -0.5,
            "I": 0.0,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "忍不了一点，喜欢就是会表现出来",
          "raw": {
            "E": 2.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 2.0,
            "M": -0.25,
            "A": -0.5,
            "D": 0.0,
            "S": -0.5,
            "R": 0.5,
            "I": 0.0,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "嘴上没什么变化，行动会越来越明显",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 2.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -1.0,
            "M": -0.25,
            "A": 1.5,
            "D": 0.0,
            "S": 0.5,
            "R": -0.5,
            "I": 0.0,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "越在意越爱逗他，正经话反而不会说",
          "raw": {
            "E": 1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 2.0,
            "G": 0.0
          },
          "centered": {
            "E": 1.0,
            "M": -0.25,
            "A": -0.5,
            "D": 0.0,
            "S": -0.5,
            "R": 0.5,
            "I": 0.0,
            "C": 0.0,
            "H": 1.5,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 6,
      "text": "如果一个人突然几个小时没回你消息，你通常最容易：",
      "options": [
        {
          "id": "A",
          "text": "没事，各忙各的",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": -1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -1.0,
            "M": -0.5,
            "A": 0.0,
            "D": -0.25,
            "S": -1.25,
            "R": -0.5,
            "I": 0.25,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "会有一点不安，但不会马上问",
          "raw": {
            "E": -1.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -1.0,
            "M": 0.5,
            "A": 0.0,
            "D": -0.25,
            "S": 0.75,
            "R": -0.5,
            "I": 0.25,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "忍到一定程度会直接问“你干吗去了？”",
          "raw": {
            "E": 2.0,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 2.0,
            "M": -0.5,
            "A": 0.0,
            "D": 0.75,
            "S": 0.75,
            "R": -0.5,
            "I": 0.25,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "脑子已经自己写完八集连续剧",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 2.0,
            "I": -1.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.5,
            "A": 0.0,
            "D": -0.25,
            "S": -0.25,
            "R": 1.5,
            "I": -0.75,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 7,
      "text": "真正吵起来的时候，你更希望另一半：",
      "options": [
        {
          "id": "A",
          "text": "当场说清楚，不许问题过夜",
          "raw": {
            "E": 2.0,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 1.25,
            "M": -0.5,
            "A": 0.0,
            "D": 1.0,
            "S": 0.0,
            "R": 0.0,
            "I": -0.25,
            "C": 0.0,
            "H": 0.0,
            "G": -0.25
          }
        },
        {
          "id": "B",
          "text": "先各自冷静，别在气头上互相伤害",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": -1.0,
            "I": 1.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -1.75,
            "M": -0.5,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": -1.0,
            "I": 0.75,
            "C": 0.0,
            "H": 0.0,
            "G": -0.25
          }
        },
        {
          "id": "C",
          "text": "可以吵，但别逃，吵完一定得抱回来",
          "raw": {
            "E": 1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 2.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 1.0
          },
          "centered": {
            "E": 0.25,
            "M": -0.5,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": 1.0,
            "I": -0.25,
            "C": 0.0,
            "H": 0.0,
            "G": 0.75
          }
        },
        {
          "id": "D",
          "text": "先把你情绪接住，谁对谁错晚点再讲",
          "raw": {
            "E": 1.0,
            "M": 2.0,
            "A": 0.0,
            "D": -1.0,
            "S": 0.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": 1.5,
            "A": 0.0,
            "D": -1.0,
            "S": -1.0,
            "R": 0.0,
            "I": -0.25,
            "C": 0.0,
            "H": 0.0,
            "G": -0.25
          }
        }
      ]
    },
    {
      "id": 8,
      "text": "如果他吃醋了，你最能接受哪一种？",
      "options": [
        {
          "id": "A",
          "text": "很直接：“对，我就是不爽。”",
          "raw": {
            "E": 2.0,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 1.75,
            "M": -0.25,
            "A": -0.25,
            "D": 0.75,
            "S": -0.25,
            "R": 0.5,
            "I": -0.25,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "嘴硬得要死，但一看就知道",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -1.25,
            "M": -0.25,
            "A": 0.75,
            "D": -0.25,
            "S": -0.25,
            "R": 0.5,
            "I": -0.25,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "完全不限制你，只是会变得安静一点",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 0.0,
            "D": -1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": 0.75,
            "A": -0.25,
            "D": -1.25,
            "S": 0.75,
            "R": -0.5,
            "I": -0.25,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "表面云淡风轻，回头精准阴阳两句",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 0.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 2.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": -0.25,
            "A": -0.25,
            "D": 0.75,
            "S": -0.25,
            "R": -0.5,
            "I": 0.75,
            "C": 0.0,
            "H": 1.5,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 9,
      "text": "他突然接到一个特别重要的机会，但意味着你们可能一年见不了几次。你更容易接受：",
      "options": [
        {
          "id": "A",
          "text": "去吧，真正喜欢不应该互相拖住",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": -1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 2.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": 0.0,
            "A": 0.0,
            "D": -1.0,
            "S": -0.5,
            "R": 0.0,
            "I": -0.25,
            "C": 1.75,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "B",
          "text": "可以去，但我们必须把未来讲清楚",
          "raw": {
            "E": 1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 2.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.75,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.5,
            "R": 0.0,
            "I": 0.75,
            "C": -0.25,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "C",
          "text": "如果关系已经够深，我希望他认真考虑留下",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 2.0,
            "R": -1.0,
            "I": 0.0,
            "C": -1.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 0.5,
            "R": -1.0,
            "I": -0.25,
            "C": -1.25,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "D",
          "text": "我甚至愿意一起换城市，看看能不能把人生重新拼一下",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 2.0
          },
          "centered": {
            "E": -0.25,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": -0.5,
            "R": 1.0,
            "I": -0.25,
            "C": -0.25,
            "H": 0.0,
            "G": 1.5
          }
        }
      ]
    },
    {
      "id": 10,
      "text": "生日那天，你最喜欢哪种惊喜？",
      "options": [
        {
          "id": "A",
          "text": "很贵重、很郑重，而且他明显准备了很久",
          "raw": {
            "E": 1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 1.0,
            "M": -0.5,
            "A": 0.0,
            "D": 0.75,
            "S": -0.5,
            "R": 0.0,
            "I": -0.25,
            "C": 0.0,
            "H": -0.5,
            "G": -0.25
          }
        },
        {
          "id": "B",
          "text": "没什么排场，但每一个细节都记得",
          "raw": {
            "E": 0.0,
            "M": 2.0,
            "A": 0.0,
            "D": 0.0,
            "S": 2.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 1.5,
            "A": 0.0,
            "D": -0.25,
            "S": 1.5,
            "R": -1.0,
            "I": -0.25,
            "C": 0.0,
            "H": -0.5,
            "G": -0.25
          }
        },
        {
          "id": "C",
          "text": "临时把你拐走，完全不知道下一站去哪",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 2.0,
            "I": 0.0,
            "C": 0.0,
            "H": 1.0,
            "G": 1.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.5,
            "A": 0.0,
            "D": -0.25,
            "S": -0.5,
            "R": 1.0,
            "I": -0.25,
            "C": 0.0,
            "H": 0.5,
            "G": 0.75
          }
        },
        {
          "id": "D",
          "text": "表面像忘了，最后突然来个大的",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": 1.0,
            "C": 0.0,
            "H": 1.0,
            "G": 0.0
          },
          "centered": {
            "E": -1.0,
            "M": -0.5,
            "A": 0.0,
            "D": -0.25,
            "S": -0.5,
            "R": 0.0,
            "I": 0.75,
            "C": 0.0,
            "H": 0.5,
            "G": -0.25
          }
        }
      ]
    },
    {
      "id": 11,
      "text": "你的闺蜜第一次见完他，回来跟你说：“这个人我看不太透。”你的第一反应比较像？",
      "options": [
        {
          "id": "A",
          "text": "正常，我自己也没完全看透",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.75,
            "M": -0.5,
            "A": 0.0,
            "D": 0.0,
            "S": -0.5,
            "R": 0.25,
            "I": -0.75,
            "C": 0.0,
            "H": -0.25,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "没关系，我知道他对我是什么样就够了",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 2.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": 0.5,
            "A": 0.0,
            "D": 0.0,
            "S": 1.5,
            "R": -0.75,
            "I": -0.75,
            "C": 0.0,
            "H": -0.25,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "那我会认真听听闺蜜为什么这么说",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 0.0,
            "I": 2.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": 0.5,
            "A": 0.0,
            "D": 0.0,
            "S": -0.5,
            "R": -0.75,
            "I": 1.25,
            "C": 0.0,
            "H": -0.25,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "越看不透，我怎么还有点想研究一下",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 2.0,
            "I": 1.0,
            "C": 0.0,
            "H": 1.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": -0.5,
            "A": 0.0,
            "D": 0.0,
            "S": -0.5,
            "R": 1.25,
            "I": 0.25,
            "C": 0.0,
            "H": 0.75,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 12,
      "text": "如果真的发生一件有点危险的事，你更想要的是：",
      "options": [
        {
          "id": "A",
          "text": "他第一时间挡在你前面",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 2.0,
            "D": 2.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.5,
            "D": 1.5,
            "S": -0.25,
            "R": 1.0,
            "I": -0.75,
            "C": 0.0,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "B",
          "text": "他保持冷静，把你先带离现场",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 2.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.5,
            "D": -0.5,
            "S": 0.75,
            "R": 0.0,
            "I": 0.25,
            "C": 0.0,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "C",
          "text": "他已经提前预判到这事根本不会发生",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": 0.0,
            "R": -2.0,
            "I": 2.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": -0.5,
            "D": -0.5,
            "S": -0.25,
            "R": -2.0,
            "I": 1.25,
            "C": 0.0,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "D",
          "text": "他没那么强，但你们两个一起硬扛过去",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 2.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": -0.5,
            "D": -0.5,
            "S": -0.25,
            "R": 1.0,
            "I": -0.75,
            "C": 0.0,
            "H": 0.0,
            "G": 1.5
          }
        }
      ]
    },
    {
      "id": 13,
      "text": "一个完全没有安排的周末，你最想和他：",
      "options": [
        {
          "id": "A",
          "text": "在家瘫一天，各玩各的也很舒服",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 2.0,
            "R": -1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 1.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.25,
            "A": 0.0,
            "D": -0.25,
            "S": 1.0,
            "R": -1.75,
            "I": 0.0,
            "C": 0.0,
            "H": 0.25,
            "G": -0.5
          }
        },
        {
          "id": "B",
          "text": "临时决定去一个没去过的地方",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 2.0,
            "I": 0.0,
            "C": 0.0,
            "H": 1.0,
            "G": 1.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.25,
            "A": 0.0,
            "D": -0.25,
            "S": -1.0,
            "R": 1.25,
            "I": 0.0,
            "C": 0.0,
            "H": 0.25,
            "G": 0.5
          }
        },
        {
          "id": "C",
          "text": "吃饭散步逛超市，把普通日子过得很好",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 2.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 1.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.75,
            "A": 0.0,
            "D": -0.25,
            "S": 1.0,
            "R": -0.75,
            "I": 0.0,
            "C": 0.0,
            "H": -0.75,
            "G": 0.5
          }
        },
        {
          "id": "D",
          "text": "他突然神秘兮兮：“别问，跟我走。”",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 0.0,
            "R": 2.0,
            "I": 0.0,
            "C": 0.0,
            "H": 1.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.25,
            "A": 0.0,
            "D": 0.75,
            "S": -1.0,
            "R": 1.25,
            "I": 0.0,
            "C": 0.0,
            "H": 0.25,
            "G": -0.5
          }
        }
      ]
    },
    {
      "id": 14,
      "text": "一段关系里，你最怕哪一种感觉？",
      "options": [
        {
          "id": "A",
          "text": "我永远猜不透他到底爱不爱我",
          "raw": {
            "E": 2.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 1.5,
            "M": 0.25,
            "A": 0.0,
            "D": 0.5,
            "S": 1.0,
            "R": 0.0,
            "I": 0.25,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "他很爱我，但我越来越没有自己的空间",
          "raw": {
            "E": 0.0,
            "M": -1.0,
            "A": 0.0,
            "D": -2.0,
            "S": -1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.5,
            "M": -0.75,
            "A": 0.0,
            "D": -1.5,
            "S": -1.0,
            "R": 0.0,
            "I": 0.25,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "两个人很稳定，却慢慢没有心动",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 2.0,
            "R": -2.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.5,
            "M": 0.25,
            "A": 0.0,
            "D": 0.5,
            "S": 2.0,
            "R": -2.0,
            "I": 0.25,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "很上头，可我永远不知道明天会发生什么",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": -2.0,
            "R": 2.0,
            "I": -1.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.5,
            "M": 0.25,
            "A": 0.0,
            "D": 0.5,
            "S": -2.0,
            "R": 2.0,
            "I": -0.75,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 15,
      "text": "假设你事业突然进入一个很拼的阶段，经常忙到顾不上他。你希望他：",
      "options": [
        {
          "id": "A",
          "text": "完全理解，各自搞事业",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": -1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 2.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": -1.0,
            "A": -0.75,
            "D": -0.75,
            "S": 0.0,
            "R": 0.0,
            "I": -0.25,
            "C": 1.5,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "会想你、会抱怨，但还是支持你",
          "raw": {
            "E": 1.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 2.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.75,
            "M": 0.0,
            "A": -0.75,
            "D": 0.25,
            "S": 1.0,
            "R": 0.0,
            "I": -0.25,
            "C": -0.5,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "主动替你分掉生活里很多麻烦",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 2.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": 0.0,
            "A": 1.25,
            "D": 0.25,
            "S": 0.0,
            "R": 0.0,
            "I": -0.25,
            "C": -0.5,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "拉你一把：“你可以拼，但不能把自己拼没了。”",
          "raw": {
            "E": 0.0,
            "M": 2.0,
            "A": 1.0,
            "D": 0.0,
            "S": 0.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": 1.0,
            "A": 0.25,
            "D": 0.25,
            "S": -1.0,
            "R": 0.0,
            "I": 0.75,
            "C": -0.5,
            "H": 0.0,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 16,
      "text": "哪一种“偏爱”最容易戳到你？",
      "options": [
        {
          "id": "A",
          "text": "对所有人都有原则，唯独会为你破例",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -1.0,
            "M": -0.25,
            "A": -0.5,
            "D": 1.0,
            "S": -0.5,
            "R": 0.75,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "B",
          "text": "不怎么说，但关键时刻永远先选你",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 2.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -1.0,
            "M": -0.25,
            "A": 1.5,
            "D": 0.0,
            "S": 0.5,
            "R": -0.25,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "C",
          "text": "全世界都看得出来他偏你",
          "raw": {
            "E": 2.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 2.0,
            "M": -0.25,
            "A": -0.5,
            "D": 0.0,
            "S": 0.5,
            "R": -0.25,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "D",
          "text": "他甚至会帮你变得更强，而不是只把你护在身后",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 0.0,
            "D": -1.0,
            "S": 0.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 2.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.75,
            "A": -0.5,
            "D": -1.0,
            "S": -0.5,
            "R": -0.25,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 1.5
          }
        }
      ]
    },
    {
      "id": 17,
      "text": "如果他真的犯了一个让你很生气的错误，你更吃哪种道歉？",
      "options": [
        {
          "id": "A",
          "text": "认错很快，不找借口",
          "raw": {
            "E": 2.0,
            "M": 1.0,
            "A": 0.0,
            "D": -1.0,
            "S": 0.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 1.5,
            "M": 0.25,
            "A": -0.5,
            "D": -0.75,
            "S": -0.25,
            "R": 0.0,
            "I": -0.5,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "不太会说，但第二天已经把问题解决了",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 2.0,
            "D": 0.0,
            "S": 0.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -1.5,
            "M": -0.75,
            "A": 1.5,
            "D": 0.25,
            "S": -0.25,
            "R": 0.0,
            "I": -0.5,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "把事情为什么发生、以后怎么避免都讲清楚",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 2.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.5,
            "M": 0.25,
            "A": -0.5,
            "D": 0.25,
            "S": 0.75,
            "R": 0.0,
            "I": 1.5,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "先认真道歉，最后再把你哄笑",
          "raw": {
            "E": 1.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 2.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.5,
            "M": 0.25,
            "A": -0.5,
            "D": 0.25,
            "S": -0.25,
            "R": 0.0,
            "I": -0.5,
            "C": 0.0,
            "H": 1.5,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 18,
      "text": "如果你做了一件明显不太理智的事，他会怎么处理最让你舒服？",
      "options": [
        {
          "id": "A",
          "text": "站你这边，回家再骂你",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": 1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.5,
            "D": 0.5,
            "S": 0.5,
            "R": -0.5,
            "I": -0.75,
            "C": 0.0,
            "H": -0.25,
            "G": -0.5
          }
        },
        {
          "id": "B",
          "text": "当场阻止你，因为他知道后果",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": 2.0,
            "S": 0.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.5,
            "D": 1.5,
            "S": -0.5,
            "R": -0.5,
            "I": 0.25,
            "C": 0.0,
            "H": -0.25,
            "G": -0.5
          }
        },
        {
          "id": "C",
          "text": "让你自己选，但把风险全告诉你",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": -1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 2.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": -0.5,
            "D": -1.5,
            "S": 0.5,
            "R": -0.5,
            "I": 1.25,
            "C": 0.0,
            "H": -0.25,
            "G": -0.5
          }
        },
        {
          "id": "D",
          "text": "“行，你非要疯是吧？那我陪你。”",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 2.0,
            "I": 0.0,
            "C": 0.0,
            "H": 1.0,
            "G": 2.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": -0.5,
            "D": -0.5,
            "S": -0.5,
            "R": 1.5,
            "I": -0.75,
            "C": 0.0,
            "H": 0.75,
            "G": 1.5
          }
        }
      ]
    },
    {
      "id": 19,
      "text": "到了一个全是陌生人的局，你更容易被哪种男人吸引？",
      "options": [
        {
          "id": "A",
          "text": "话不多，但所有人明显都很尊重他",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 2.0,
            "S": 0.0,
            "R": 0.0,
            "I": 0.0,
            "C": 1.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.75,
            "M": -0.25,
            "A": 0.0,
            "D": 1.5,
            "S": 0.25,
            "R": -0.25,
            "I": -0.75,
            "C": 0.75,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "跟谁都聊得来，场子完全不会冷",
          "raw": {
            "E": 2.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 2.0,
            "G": 0.0
          },
          "centered": {
            "E": 2.25,
            "M": -0.25,
            "A": 0.0,
            "D": -0.5,
            "S": 0.25,
            "R": 0.75,
            "I": -0.75,
            "C": -0.25,
            "H": 1.5,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "自己坐在角落里，明显懒得社交",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": -1.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.75,
            "M": -0.25,
            "A": 0.0,
            "D": -0.5,
            "S": -0.75,
            "R": -0.25,
            "I": 0.25,
            "C": -0.25,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "看起来温温柔柔，但你总觉得他什么都知道",
          "raw": {
            "E": -1.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 0.0,
            "I": 2.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.75,
            "M": 0.75,
            "A": 0.0,
            "D": -0.5,
            "S": 0.25,
            "R": -0.25,
            "I": 1.25,
            "C": -0.25,
            "H": -0.5,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 20,
      "text": "下面这些“小毛病”，哪一种你反而可能觉得有点可爱？",
      "options": [
        {
          "id": "A",
          "text": "嘴硬得离谱",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 1.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.75,
            "M": -0.25,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 1.0,
            "I": -0.75,
            "C": 0.0,
            "H": -0.25,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "谨慎过头，干什么都先想八百遍",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": -1.0,
            "I": 2.0,
            "C": 0.0,
            "H": 1.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": -0.25,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": -1.0,
            "I": 1.25,
            "C": 0.0,
            "H": -0.25,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "明明很聪明，有时候生活能力却很奇怪",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": -1.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 1.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": -0.25,
            "A": 0.0,
            "D": 0.0,
            "S": -1.0,
            "R": 0.0,
            "I": 0.25,
            "C": 0.0,
            "H": -0.25,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "表面成熟稳重，私下其实挺幼稚",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 2.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": 0.75,
            "A": 0.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": -0.75,
            "C": 0.0,
            "H": 0.75,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 21,
      "text": "如果你得到一个特别好的机会，要一个人去很远的地方三年。你最想听到哪一句？",
      "options": [
        {
          "id": "A",
          "text": "“去，我等你。”",
          "raw": {
            "E": 1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 2.0,
            "R": 0.0,
            "I": 0.0,
            "C": 1.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.75,
            "M": -0.25,
            "A": -0.25,
            "D": 0.25,
            "S": 1.5,
            "R": 0.0,
            "I": -0.25,
            "C": 0.0,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "B",
          "text": "“去，我想办法跟过去。”",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 2.0
          },
          "centered": {
            "E": -0.25,
            "M": -0.25,
            "A": 0.75,
            "D": 0.25,
            "S": 0.5,
            "R": 0.0,
            "I": -0.25,
            "C": -1.0,
            "H": 0.0,
            "G": 1.5
          }
        },
        {
          "id": "C",
          "text": "“我们先别承诺三年后，先把每一天过好。”",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": -1.0,
            "R": 0.0,
            "I": 1.0,
            "C": 1.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": -0.25,
            "A": -0.25,
            "D": 0.25,
            "S": -1.5,
            "R": 0.0,
            "I": 0.75,
            "C": 0.0,
            "H": 0.0,
            "G": -0.5
          }
        },
        {
          "id": "D",
          "text": "“你要的是这个机会，我不会成为你放弃它的理由。”",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 0.0,
            "D": -1.0,
            "S": 0.0,
            "R": 0.0,
            "I": 0.0,
            "C": 2.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": 0.75,
            "A": -0.25,
            "D": -0.75,
            "S": -0.5,
            "R": 0.0,
            "I": -0.25,
            "C": 1.0,
            "H": 0.0,
            "G": -0.5
          }
        }
      ]
    },
    {
      "id": 22,
      "text": "如果两个人同时跌到人生低谷，你更相信哪种关系？",
      "options": [
        {
          "id": "A",
          "text": "我们两个一起慢慢爬出去",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 2.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 2.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": -0.25,
            "D": 0.25,
            "S": 1.5,
            "R": 0.25,
            "I": -0.25,
            "C": 0.0,
            "H": -0.5,
            "G": 1.0
          }
        },
        {
          "id": "B",
          "text": "谁先缓过来，谁就先拉另一个",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 1.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.75,
            "D": 0.25,
            "S": 0.5,
            "R": 0.25,
            "I": -0.25,
            "C": 0.0,
            "H": -0.5,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "再难也别互相增加负担，各自先站稳",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": -1.0,
            "S": -1.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": -0.25,
            "D": -0.75,
            "S": -1.5,
            "R": 0.25,
            "I": 0.75,
            "C": 0.0,
            "H": -0.5,
            "G": -1.0
          }
        },
        {
          "id": "D",
          "text": "都这样了，还能一起开玩笑，就没什么过不去",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": -1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 2.0,
            "G": 1.0
          },
          "centered": {
            "E": 0.0,
            "M": 0.0,
            "A": -0.25,
            "D": 0.25,
            "S": -0.5,
            "R": -0.75,
            "I": -0.25,
            "C": 0.0,
            "H": 1.5,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 23,
      "text": "如果你的“盖世英雄”真的要登场，你更希望他是：",
      "options": [
        {
          "id": "A",
          "text": "所有人都觉得他很厉害，只有你知道他也会累",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 2.0,
            "D": 2.0,
            "S": 0.0,
            "R": 0.0,
            "I": 0.0,
            "C": 1.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": 0.0,
            "A": 0.25,
            "D": 1.5,
            "S": 0.0,
            "R": -0.25,
            "I": 0.0,
            "C": 0.75,
            "H": -0.5,
            "G": -0.5
          }
        },
        {
          "id": "B",
          "text": "一开始谁都看不起，后来一步步把所有人打服",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": 0.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 1.0,
            "G": 2.0
          },
          "centered": {
            "E": 0.25,
            "M": 0.0,
            "A": -0.75,
            "D": -0.5,
            "S": 0.0,
            "R": -0.25,
            "I": 0.0,
            "C": -0.25,
            "H": 0.5,
            "G": 1.5
          }
        },
        {
          "id": "C",
          "text": "表面完全不像英雄，关键时候却从不掉链子",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 2.0,
            "D": 0.0,
            "S": 0.0,
            "R": -1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 1.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": 0.0,
            "A": 0.25,
            "D": -0.5,
            "S": 0.0,
            "R": -1.25,
            "I": 0.0,
            "C": -0.25,
            "H": 0.5,
            "G": -0.5
          }
        },
        {
          "id": "D",
          "text": "看起来就很危险，但偏偏从来没把危险留给你",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 2.0,
            "D": 0.0,
            "S": 0.0,
            "R": 2.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.75,
            "M": 0.0,
            "A": 0.25,
            "D": -0.5,
            "S": 0.0,
            "R": 1.75,
            "I": 0.0,
            "C": -0.25,
            "H": -0.5,
            "G": -0.5
          }
        }
      ]
    },
    {
      "id": 24,
      "text": "如果把你们的关系拍成电视剧，你最想看哪一种？",
      "options": [
        {
          "id": "A",
          "text": "从互相看不顺眼到谁也离不开谁",
          "raw": {
            "E": 1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 2.0,
            "I": 0.0,
            "C": 0.0,
            "H": 1.0,
            "G": 0.0
          },
          "centered": {
            "E": 1.25,
            "M": 0.0,
            "A": -0.5,
            "D": -0.25,
            "S": -0.25,
            "R": 1.25,
            "I": -0.5,
            "C": -0.25,
            "H": 0.75,
            "G": -0.5
          }
        },
        {
          "id": "B",
          "text": "两个普通人一起升级，最后站到更高的地方",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 2.0
          },
          "centered": {
            "E": 0.25,
            "M": 0.0,
            "A": 0.5,
            "D": -0.25,
            "S": 0.75,
            "R": -0.75,
            "I": -0.5,
            "C": -0.25,
            "H": -0.25,
            "G": 1.5
          }
        },
        {
          "id": "C",
          "text": "他一直没说，但观众早就看出来他爱惨了",
          "raw": {
            "E": -2.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": 0.0,
            "R": 0.0,
            "I": 0.0,
            "C": 1.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -1.75,
            "M": 0.0,
            "A": 0.5,
            "D": -0.25,
            "S": -0.25,
            "R": -0.75,
            "I": -0.5,
            "C": 0.75,
            "H": -0.25,
            "G": -0.5
          }
        },
        {
          "id": "D",
          "text": "两个聪明人互相试探，最后发现谁都没赢",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 0.0,
            "R": 1.0,
            "I": 2.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": 0.0,
            "A": -0.5,
            "D": 0.75,
            "S": -0.25,
            "R": 0.25,
            "I": 1.5,
            "C": -0.25,
            "H": -0.25,
            "G": -0.5
          }
        }
      ]
    },
    {
      "id": 25,
      "text": "真的出大事的时候，四种“保护你”的方式，你最吃哪一种？",
      "options": [
        {
          "id": "A",
          "text": "先把你送到安全的地方，再回头把事情处理干净",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 2.0,
            "D": 1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 1.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.5,
            "A": 0.75,
            "D": 0.5,
            "S": 0.0,
            "R": 0.25,
            "I": -0.5,
            "C": 0.75,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "谁敢动你，他会当场把问题压下去",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 2.0,
            "D": 2.0,
            "S": 0.0,
            "R": 1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.5,
            "A": 0.75,
            "D": 1.5,
            "S": -1.0,
            "R": 1.25,
            "I": -0.5,
            "C": -0.25,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "最好事情发生前就已经预判，并准备好几套退路",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": 1.0,
            "R": -2.0,
            "I": 2.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": -0.5,
            "A": -0.25,
            "D": -0.5,
            "S": 0.0,
            "R": -1.75,
            "I": 1.5,
            "C": -0.25,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "不抢你的决定权，但从头到尾陪你把事情处理完",
          "raw": {
            "E": 0.0,
            "M": 2.0,
            "A": 0.0,
            "D": -1.0,
            "S": 2.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.0,
            "M": 1.5,
            "A": -1.25,
            "D": -1.5,
            "S": 1.0,
            "R": 0.25,
            "I": -0.5,
            "C": -0.25,
            "H": 0.0,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 26,
      "text": "四个都很聪明的人，你最容易对哪种上头？",
      "options": [
        {
          "id": "A",
          "text": "会布局，但从不让你看见他到底布局了多少",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 0.0,
            "I": 2.0,
            "C": 1.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.75,
            "M": -0.25,
            "A": 0.0,
            "D": -0.25,
            "S": 0.0,
            "R": 0.25,
            "I": 0.25,
            "C": 0.75,
            "H": -0.75,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "什么都算得很清楚，唯独最后把自己算进爱情里",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 1.0,
            "S": 0.0,
            "R": 1.0,
            "I": 2.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": -0.25,
            "A": 0.0,
            "D": 0.75,
            "S": 0.0,
            "R": 1.25,
            "I": 0.25,
            "C": -0.25,
            "H": -0.75,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "聪明得很松弛，平时看起来甚至有点不正经",
          "raw": {
            "E": 0.0,
            "M": 1.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 0.0,
            "I": 1.0,
            "C": 0.0,
            "H": 2.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": 0.75,
            "A": 0.0,
            "D": -0.25,
            "S": 0.0,
            "R": 0.25,
            "I": -0.75,
            "C": -0.25,
            "H": 1.25,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "聪明到根本不想卷，能避开的风险绝不硬碰",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": -2.0,
            "I": 2.0,
            "C": 0.0,
            "H": 1.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": -0.25,
            "A": 0.0,
            "D": -0.25,
            "S": 0.0,
            "R": -1.75,
            "I": 0.25,
            "C": -0.25,
            "H": 0.25,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 27,
      "text": "下面四种恋爱，你明知道有代价，还是最想选哪一种？",
      "options": [
        {
          "id": "A",
          "text": "很稳定、很温柔，但刺激感不会特别强",
          "raw": {
            "E": 0.0,
            "M": 2.0,
            "A": 0.0,
            "D": 0.0,
            "S": 2.0,
            "R": -2.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.25,
            "M": 1.0,
            "A": -0.25,
            "D": 0.25,
            "S": 2.0,
            "R": -1.75,
            "I": 0.0,
            "C": -0.5,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "B",
          "text": "很爱你，但他身上永远背着比爱情更大的东西",
          "raw": {
            "E": -1.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": -1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 2.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.75,
            "M": -1.0,
            "A": 0.75,
            "D": 0.25,
            "S": -1.0,
            "R": 0.25,
            "I": 0.0,
            "C": 1.5,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "C",
          "text": "浓度极高，上头是真的，累也是真的",
          "raw": {
            "E": 1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": -1.0,
            "R": 2.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": 1.25,
            "M": -1.0,
            "A": -0.25,
            "D": 0.25,
            "S": -1.0,
            "R": 2.25,
            "I": 0.0,
            "C": -0.5,
            "H": 0.0,
            "G": 0.0
          }
        },
        {
          "id": "D",
          "text": "他不太像标准男朋友，但灵魂上特别懂你",
          "raw": {
            "E": -1.0,
            "M": 2.0,
            "A": 0.0,
            "D": -1.0,
            "S": 0.0,
            "R": -1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.75,
            "M": 1.0,
            "A": -0.25,
            "D": -0.75,
            "S": 0.0,
            "R": -0.75,
            "I": 0.0,
            "C": -0.5,
            "H": 0.0,
            "G": 0.0
          }
        }
      ]
    },
    {
      "id": 28,
      "text": "最后一题。你更想要怎样的“盖世英雄”？",
      "options": [
        {
          "id": "A",
          "text": "已经很强的人，转身替我撑住世界",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 2.0,
            "D": 1.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": -0.5,
            "A": 1.25,
            "D": 1.0,
            "S": 0.5,
            "R": -0.25,
            "I": 0.0,
            "C": 0.0,
            "H": -0.5,
            "G": -0.5
          }
        },
        {
          "id": "B",
          "text": "和我一起从低谷往上爬的人",
          "raw": {
            "E": 0.0,
            "M": 0.0,
            "A": 1.0,
            "D": 0.0,
            "S": 1.0,
            "R": 0.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 2.0
          },
          "centered": {
            "E": -0.25,
            "M": -0.5,
            "A": 0.25,
            "D": 0.0,
            "S": 0.5,
            "R": -0.25,
            "I": 0.0,
            "C": 0.0,
            "H": -0.5,
            "G": 1.5
          }
        },
        {
          "id": "C",
          "text": "能看懂我，比“拯救我”更重要的人",
          "raw": {
            "E": 0.0,
            "M": 2.0,
            "A": 0.0,
            "D": -1.0,
            "S": 0.0,
            "R": -1.0,
            "I": 0.0,
            "C": 0.0,
            "H": 0.0,
            "G": 0.0
          },
          "centered": {
            "E": -0.25,
            "M": 1.5,
            "A": -0.75,
            "D": -1.0,
            "S": -0.5,
            "R": -1.25,
            "I": 0.0,
            "C": 0.0,
            "H": -0.5,
            "G": -0.5
          }
        },
        {
          "id": "D",
          "text": "让我觉得人生突然变得很有意思的人",
          "raw": {
            "E": 1.0,
            "M": 0.0,
            "A": 0.0,
            "D": 0.0,
            "S": 0.0,
            "R": 2.0,
            "I": 0.0,
            "C": 0.0,
            "H": 2.0,
            "G": 0.0
          },
          "centered": {
            "E": 0.75,
            "M": -0.5,
            "A": -0.75,
            "D": 0.0,
            "S": -0.5,
            "R": 1.75,
            "I": 0.0,
            "C": 0.0,
            "H": 1.5,
            "G": -0.5
          }
        }
      ]
    }
  ],
  "characters": [
    {
      "name": "谢征",
      "vector": {
        "E": 58,
        "M": 72,
        "A": 95,
        "D": 76,
        "S": 82,
        "R": 66,
        "I": 82,
        "C": 92,
        "H": 38,
        "G": 74
      },
      "front_cards": {
        "偏爱浓度": 93,
        "守护行动力": 96,
        "情绪理解力": 78,
        "心动危险值": 66
      }
    },
    {
      "name": "公孙鄞",
      "vector": {
        "E": 52,
        "M": 91,
        "A": 74,
        "D": 44,
        "S": 77,
        "R": 45,
        "I": 94,
        "C": 78,
        "H": 55,
        "G": 63
      },
      "front_cards": {
        "偏爱浓度": 88,
        "守护行动力": 75,
        "情绪理解力": 91,
        "心动危险值": 52
      }
    },
    {
      "name": "李长寿",
      "vector": {
        "E": 38,
        "M": 66,
        "A": 88,
        "D": 32,
        "S": 86,
        "R": 20,
        "I": 100,
        "C": 84,
        "H": 78,
        "G": 60
      },
      "front_cards": {
        "偏爱浓度": 84,
        "守护行动力": 91,
        "情绪理解力": 70,
        "心动危险值": 28
      }
    },
    {
      "name": "赵凌",
      "vector": {
        "E": 76,
        "M": 70,
        "A": 88,
        "D": 58,
        "S": 72,
        "R": 52,
        "I": 62,
        "C": 70,
        "H": 84,
        "G": 96
      },
      "front_cards": {
        "偏爱浓度": 87,
        "守护行动力": 89,
        "情绪理解力": 73,
        "心动危险值": 48
      }
    },
    {
      "name": "谢燕来",
      "vector": {
        "E": 48,
        "M": 58,
        "A": 92,
        "D": 65,
        "S": 63,
        "R": 68,
        "I": 58,
        "C": 82,
        "H": 47,
        "G": 95
      },
      "front_cards": {
        "偏爱浓度": 91,
        "守护行动力": 93,
        "情绪理解力": 66,
        "心动危险值": 63
      }
    },
    {
      "name": "雷修远",
      "vector": {
        "E": 56,
        "M": 70,
        "A": 80,
        "D": 68,
        "S": 55,
        "R": 92,
        "I": 85,
        "C": 66,
        "H": 38,
        "G": 62
      },
      "front_cards": {
        "偏爱浓度": 92,
        "守护行动力": 82,
        "情绪理解力": 72,
        "心动危险值": 91
      }
    },
    {
      "name": "藏海",
      "vector": {
        "E": 35,
        "M": 61,
        "A": 82,
        "D": 62,
        "S": 58,
        "R": 69,
        "I": 99,
        "C": 94,
        "H": 28,
        "G": 70
      },
      "front_cards": {
        "偏爱浓度": 86,
        "守护行动力": 84,
        "情绪理解力": 68,
        "心动危险值": 70
      }
    },
    {
      "name": "魏劭",
      "vector": {
        "E": 61,
        "M": 56,
        "A": 94,
        "D": 88,
        "S": 73,
        "R": 84,
        "I": 72,
        "C": 89,
        "H": 30,
        "G": 66
      },
      "front_cards": {
        "偏爱浓度": 95,
        "守护行动力": 94,
        "情绪理解力": 61,
        "心动危险值": 83
      }
    },
    {
      "name": "蒋长扬",
      "vector": {
        "E": 77,
        "M": 85,
        "A": 84,
        "D": 58,
        "S": 81,
        "R": 56,
        "I": 87,
        "C": 78,
        "H": 88,
        "G": 72
      },
      "front_cards": {
        "偏爱浓度": 89,
        "守护行动力": 85,
        "情绪理解力": 86,
        "心动危险值": 57
      }
    },
    {
      "name": "许七安",
      "vector": {
        "E": 91,
        "M": 78,
        "A": 87,
        "D": 56,
        "S": 70,
        "R": 55,
        "I": 78,
        "C": 68,
        "H": 100,
        "G": 88
      },
      "front_cards": {
        "偏爱浓度": 88,
        "守护行动力": 88,
        "情绪理解力": 81,
        "心动危险值": 49
      }
    },
    {
      "name": "韩立",
      "vector": {
        "E": 28,
        "M": 54,
        "A": 89,
        "D": 34,
        "S": 80,
        "R": 18,
        "I": 96,
        "C": 82,
        "H": 42,
        "G": 78
      },
      "front_cards": {
        "偏爱浓度": 80,
        "守护行动力": 90,
        "情绪理解力": 60,
        "心动危险值": 25
      }
    },
    {
      "name": "南珩/离十六",
      "vector": {
        "E": 60,
        "M": 58,
        "A": 84,
        "D": 82,
        "S": 56,
        "R": 89,
        "I": 88,
        "C": 76,
        "H": 46,
        "G": 67
      },
      "front_cards": {
        "偏爱浓度": 91,
        "守护行动力": 86,
        "情绪理解力": 64,
        "心动危险值": 89
      }
    },
    {
      "name": "梅逐雨",
      "vector": {
        "E": 43,
        "M": 77,
        "A": 92,
        "D": 44,
        "S": 86,
        "R": 32,
        "I": 70,
        "C": 88,
        "H": 32,
        "G": 64
      },
      "front_cards": {
        "偏爱浓度": 87,
        "守护行动力": 92,
        "情绪理解力": 76,
        "心动危险值": 35
      }
    },
    {
      "name": "萧蘅",
      "vector": {
        "E": 73,
        "M": 80,
        "A": 86,
        "D": 76,
        "S": 70,
        "R": 78,
        "I": 94,
        "C": 75,
        "H": 74,
        "G": 66
      },
      "front_cards": {
        "偏爱浓度": 91,
        "守护行动力": 87,
        "情绪理解力": 80,
        "心动危险值": 78
      }
    },
    {
      "name": "慕声",
      "vector": {
        "E": 78,
        "M": 76,
        "A": 86,
        "D": 70,
        "S": 48,
        "R": 95,
        "I": 71,
        "C": 54,
        "H": 50,
        "G": 72
      },
      "front_cards": {
        "偏爱浓度": 96,
        "守护行动力": 88,
        "情绪理解力": 77,
        "心动危险值": 93
      }
    },
    {
      "name": "宋墨",
      "vector": {
        "E": 63,
        "M": 66,
        "A": 95,
        "D": 69,
        "S": 75,
        "R": 62,
        "I": 72,
        "C": 86,
        "H": 44,
        "G": 83
      },
      "front_cards": {
        "偏爱浓度": 92,
        "守护行动力": 95,
        "情绪理解力": 69,
        "心动危险值": 61
      }
    },
    {
      "name": "崔行舟",
      "vector": {
        "E": 52,
        "M": 58,
        "A": 84,
        "D": 88,
        "S": 64,
        "R": 80,
        "I": 94,
        "C": 76,
        "H": 34,
        "G": 62
      },
      "front_cards": {
        "偏爱浓度": 90,
        "守护行动力": 86,
        "情绪理解力": 62,
        "心动危险值": 82
      }
    },
    {
      "name": "李莲花",
      "vector": {
        "E": 35,
        "M": 96,
        "A": 70,
        "D": 20,
        "S": 68,
        "R": 28,
        "I": 92,
        "C": 65,
        "H": 82,
        "G": 58
      },
      "front_cards": {
        "偏爱浓度": 79,
        "守护行动力": 72,
        "情绪理解力": 96,
        "心动危险值": 32
      }
    },
    {
      "name": "笛飞声",
      "vector": {
        "E": 24,
        "M": 40,
        "A": 96,
        "D": 72,
        "S": 43,
        "R": 76,
        "I": 50,
        "C": 67,
        "H": 25,
        "G": 48
      },
      "front_cards": {
        "偏爱浓度": 78,
        "守护行动力": 94,
        "情绪理解力": 42,
        "心动危险值": 72
      }
    },
    {
      "name": "相柳",
      "vector": {
        "E": 22,
        "M": 84,
        "A": 99,
        "D": 70,
        "S": 36,
        "R": 94,
        "I": 74,
        "C": 100,
        "H": 20,
        "G": 44
      },
      "front_cards": {
        "偏爱浓度": 97,
        "守护行动力": 98,
        "情绪理解力": 86,
        "心动危险值": 92
      }
    },
    {
      "name": "涂山璟",
      "vector": {
        "E": 82,
        "M": 98,
        "A": 80,
        "D": 22,
        "S": 99,
        "R": 16,
        "I": 66,
        "C": 60,
        "H": 40,
        "G": 70
      },
      "front_cards": {
        "偏爱浓度": 94,
        "守护行动力": 82,
        "情绪理解力": 95,
        "心动危险值": 21
      }
    },
    {
      "name": "玱玹",
      "vector": {
        "E": 55,
        "M": 70,
        "A": 84,
        "D": 86,
        "S": 57,
        "R": 82,
        "I": 91,
        "C": 98,
        "H": 34,
        "G": 60
      },
      "front_cards": {
        "偏爱浓度": 93,
        "守护行动力": 85,
        "情绪理解力": 74,
        "心动危险值": 81
      }
    },
    {
      "name": "澹台烬",
      "vector": {
        "E": 88,
        "M": 62,
        "A": 91,
        "D": 92,
        "S": 35,
        "R": 100,
        "I": 68,
        "C": 48,
        "H": 20,
        "G": 58
      },
      "front_cards": {
        "偏爱浓度": 99,
        "守护行动力": 91,
        "情绪理解力": 69,
        "心动危险值": 99
      }
    },
    {
      "name": "东方青苍",
      "vector": {
        "E": 66,
        "M": 68,
        "A": 99,
        "D": 95,
        "S": 65,
        "R": 88,
        "I": 72,
        "C": 85,
        "H": 38,
        "G": 62
      },
      "front_cards": {
        "偏爱浓度": 96,
        "守护行动力": 98,
        "情绪理解力": 72,
        "心动危险值": 86
      }
    },
    {
      "name": "凌不疑",
      "vector": {
        "E": 58,
        "M": 57,
        "A": 100,
        "D": 90,
        "S": 58,
        "R": 92,
        "I": 80,
        "C": 96,
        "H": 28,
        "G": 60
      },
      "front_cards": {
        "偏爱浓度": 98,
        "守护行动力": 99,
        "情绪理解力": 65,
        "心动危险值": 90
      }
    }
  ],
  "calibration": {
    "response_mean": {
      "E": 0.00482,
      "M": -0.0087,
      "A": 0.01578,
      "D": 0.02826,
      "S": -0.02256,
      "R": 0.01642,
      "I": -0.01513,
      "C": 0.01028,
      "H": 0.00448,
      "G": -0.00976
    },
    "response_std": {
      "E": 3.968695852241937,
      "M": 2.883639074156496,
      "A": 2.940799379692751,
      "D": 3.561139055471086,
      "S": 3.8867661424885984,
      "R": 4.404454606824352,
      "I": 3.2223688620476962,
      "C": 2.0836300827159246,
      "H": 2.981737736554824,
      "G": 2.835310343225359
    },
    "character_mean": {
      "E": 56.76,
      "M": 70.04,
      "A": 87.96,
      "D": 64.68,
      "S": 66.28,
      "R": 65.48,
      "I": 79.8,
      "C": 78.28,
      "H": 47.8,
      "G": 67.92
    },
    "character_std": {
      "E": 19.140073145105795,
      "M": 13.724372481100911,
      "A": 7.437634032405736,
      "D": 21.3536320095669,
      "S": 15.54997106106632,
      "R": 25.741981275729344,
      "I": 13.37460279784039,
      "C": 13.379147954933455,
      "H": 22.51577224969199,
      "G": 12.393288506284359
    }
  },
  "algorithm": {
    "1": "Each option has a 10D raw vector.",
    "2": "For each question subtract the mean vector of its 4 options (question centering).",
    "3": "Sum selected centered vectors across 28 questions => user_raw.",
    "4": "user_z=(user_raw-response_mean)/response_std.",
    "5": "character_z=(character_raw-character_mean)/character_std.",
    "6": "distance=sqrt(sum(weight_d*(user_z-character_z)^2)/sum(weights)); minimum wins.",
    "7": "Keep Top1/Top2/Top3. Top1 always remains the minimum weighted distance. If Top2.distance - Top1.distance < 0.05, set close_match=true and optionally surface Top2 as a hidden-fit result; do not override Top1.",
    "8": "Q25-Q28 are high-discrimination questions but use the same scoring formula as all other questions; no manual tie-break or extra override.",
    "9": "UI 契合指数不是概率；根据Top1距离与Top1/Top2分离度映射到82-98。"
  }
}